<template>
  <div>
    <div class="ed-itemTabs clr">
      <template v-if="item.fair_ids">
        <template v-for="(eventId, index) in item.fair_ids">
          <template v-if="eventId in eventLookup">
            <Flag :key="index" :event-id="Number.parseInt(eventId)" :event-lookup="eventLookup"/>
          </template>
        </template>
      </template>
      <!--v-for="tabFeature in item.tabFeature"-->
      <!--:key="tabFeature.name"-->
      <!--class="ed-itemTab ed-itemTab&#45;&#45;feature">-->
      <!--{{tabFeature.name}}-->
      <!--</span>-->
      <template v-if="item.av_badges">
        <template v-for="(badge, index) in item.av_badges">
          <span
            :key="index"
            class="ed-itemTab ed-itemTab--feature"
            v-if="badge.type === 0">
          {{ badge.title }}
        </span>
        </template>
      </template>
    </div>
    <div class="ed-grid">
      <div class="ed-grid__item ed-grid__item--1">
        <template v-if="item.type === getExhibitorType">
          <img
            v-if="item.av_logo"
            class="ed-item__logo ed-item__logo--link"
            :src="item.av_logo"
            @click="updateRoute(item)"
            aria-haspopup="true"
            :title="$t('list.linkToDetailTooltip')"
            :alt="item.title"/>
        </template>
        <template v-else-if="item.type === getNewsType">
          <img
            v-if="getFirstImage(item.av_news_image_url)"
            class="ed-item__logo ed-item__logo--link"
            :src="getFirstImage(item.av_news_image_url)"
            @click="updateRoute(item)"
            aria-haspopup="true"
            :title="$t('list.linkToDetailTooltip')"
            :alt="item.title"/>
        </template>
        <template v-else>
          <img
            v-if="item.av_logo"
            class="ed-item__logo"
            :src="item.av_logo"
            :alt="item.title"/>
        </template>
      </div>

      <div class="ed-grid__item ed-grid__item--2" :class="{'ed-grid__item--2--terminalMode': terminalmode}">
        <div class="ed-text">
          <span class="ed-text__small">
            {{ returnItemType(item.type) }}

            <template v-if="item.av_booths">
              <template v-for="(booth, index) in item.av_booths">
                <template v-if="index === 0"> | </template>

                <template v-if="index < 5">
                  <template v-if="hallplan_path">
                    <a
                      :key="index"
                      class="ed-text__link--hallplan"
                      :title="$t('list.linkToHallPlan')"
                      :href="generateHallplanLink(booth)">
                      <template v-if="booth.hall && booth.hall.title !== $t('detail.fairBooths.undefined')">
                        {{ booth.hall.title }},
                      </template>
                      {{ $t('detail.fairBooths.booth') }} {{ getBoothName(booth) }}
                    </a>
                    <template v-if="booth.ebmsState">, {{ $t(`detail.fairBooths.ebmsState.${booth.ebmsState}`) }}</template>
                    <template v-if="!isLastElement(index, item.av_booths)">;</template>
                  </template>

                  <template v-else>
                    <template v-if="booth.hall && booth.hall.title !== $t('detail.fairBooths.undefined')">
                      {{ booth.hall.title }},
                    </template>
                    {{ $t('detail.fairBooths.booth') }} {{ getHallNumber(booth.hallId) }}{{ getBoothName(booth) }}
                    <template v-if="booth.ebmsState">, {{ $t(`detail.fairBooths.ebmsState.${booth.ebmsState}`) }}</template>
                    <template v-if="!isLastElement(index, item.av_booths)">; </template>
                  </template>
                </template>
              </template>

              <template v-if="item.av_booths.length > 5" > [...]</template>
            </template>

            <template v-if="item.type === getNewsType">
              | {{ item.date | moment('DD.MM.YYYY') }}
            </template>
          </span>

          <template v-if="item.type === getExhibitorType || item.type === getNewsType">
            <h3
              v-if="item.title"
              class="ed-text__title ed-text__title--link"
              @click="updateRoute(item)"
              aria-haspopup="true"
              :title="$t('list.linkToDetailTooltip')">
              {{ item.title }}
            </h3>
          </template>

          <template v-else>
            <h3
              v-if="item.title"
              class="ed-text__title">
              {{ item.title }}
            </h3>
          </template>

          <template v-if="view_size_mode !== 0 && item.content">
            <div class="ed-text__description">
              <p v-html="getCroppedText"></p>
            </div>
          </template>

          <template v-else-if="view_size_mode !== 0 && item.av_zip && item.av_city">
            <div class="ed-text__description">
              <p>
                {{ item.av_zip }} {{ item.av_city }}
                <template v-if="item.av_country">, {{ item.av_country }}</template>
              </p>
            </div>
          </template>

          <template v-if="item.av_exhibitor_brands && item.av_exhibitor_brands.length > 0">
            <span class="ed-text__small">
              {{$t('Marken')}}
            </span>

            <div class="ed-image__brands">
              <template v-for="brand in item.av_exhibitor_brands">
                <div class="ed-image__brand" :key="brand.av_brand_name">
                  <img :src="brand.av_brand_image_url" :alt="brand.av_brand_name" :title="brand.av_brand_name"/>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
      <div class="ed-grid__item ed-grid__item--3" v-if="!terminalmode">
        <div
          class="ed-item__features"
          v-if="item.av_badges">
          <img
            v-for="badge in item.av_badges"
            :key="badge.id"
            :title="badge.title"
            :alt="badge.title"
            :src="badge.imageUrl">
        </div>
      </div>
    </div>

    <ButtonComponent
      @setFavourite="setFavourite(item.id)"
      @updateRoute="updateRoute"
      :view_size_mode="view_size_mode"
      :show_favourite="true"
      :is_favourite="is_favourite"
      :terminalmode="terminalmode"
    />
  </div>
</template>

<script>
import {
  SolrBrandTypeName, SolrExhibitorTypeName, SolrNewsTypeName, SolrProductTypeName
} from '@/common/Utility';
import HallsService from '@/common/halls.service';
import Flag from './Flag.vue';
import ButtonComponent from './ButtonComponent.vue';

export default {
  name: 'ListItem',
  components: {
    Flag, ButtonComponent,
  },
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
    is_favourite: {
      type: Boolean,
      required: true,
    },
    hallplan_path: {
      type: String,
      required: true,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    eventLookup: {
      type: Object,
      required: true,
    }
  },
  computed: {
    getExhibitorType() {
      return SolrExhibitorTypeName;
    },
    getNewsType() {
      return SolrNewsTypeName;
    },
    getCroppedText() {
      return this.$root.$options.filters.crop(this.item.content, 200, '...');
    }
  },
  methods: {
    setFavourite(itemId) {
      this.$emit('setFavourite', itemId);
    },
    updateRoute() {
      this.$emit('updateRoute', this.item);
    },
    getHallNumber(hallId) {
      return HallsService.getHallNumber(hallId);
    },
    getBoothName(booth) {
      // returns only the letter and the following numbers, may be needed again in the future
      // const id = booth.hall.hallId;
      // const aisle = booth.aisleLetter;
      // const combined = id + aisle;
      // return boothName.replace(combined, '');
      return booth.boothName || '';
    },
    generateHallplanLink(booth) {
      // Not quite sure whether this works yet, so the other part is still commented
      const splittedIdentifier = booth.importBoothIdentifier.split(':');
      if (splittedIdentifier.length === 2) {
        let hallId = splittedIdentifier[0];
        const boothId = splittedIdentifier[1];

        // atr booths get redirected and displayed in EO now
        if (hallId === 'ATR') {
          hallId = 'EO';
        }

        return `${this.hallplan_path}#/${hallId}/${boothId}`;
      }

      return this.hallplan_path;

      // const fullHallId = booth.hallId;
      // // FIXME: this is a workaround for the unexpected behaviour of a
      // // booth having an already "complete" (url ready) boothId
      // const matchesCompleteBoothId = booth.boothId.match(/(\d+)([A-Z])(\d+)(\.(\d+))?/g);
      // if (matchesCompleteBoothId && matchesCompleteBoothId.length > 0
      //   && matchesCompleteBoothId[0] === booth.boothId) {
      //   return `${this.hallplan_path}#/${fullHallId}/${booth.boothId}`;
      // }
      // // code for expected behaviour
      // const hallId = fullHallId.replace(/\D/g, '');
      // const aisleLetter = booth.aisleLetter ? booth.aisleLetter : '';
      // return `${this.hallplan_path}#/${fullHallId}/${hallId}${aisleLetter}${booth.boothId}`;
    },
    returnItemType(type) {
      switch (type) {
        case SolrExhibitorTypeName:
          return this.$t('list.type.exhibitor');
        case SolrProductTypeName:
          return this.$t('list.type.product');
        case SolrNewsTypeName:
          return this.$t('list.type.news');
        case SolrBrandTypeName:
          return this.$t('list.type.brand');
        default:
          return '';
      }
    },
    isLastElement(index, field) {
      return index === field.length - 1;
    },
    getFirstImage(img) {
      let images = img;
      if (images && typeof images === 'string') {
        images = JSON.parse(images);
      }
      if (images && images.length) {
        return images[0];
      }
      return '';
    }
  },
};
</script>
<style lang="scss">
.ed-grid__item--2--terminalMode {
  width: 80% !important;
}

.ed-image__brands {
  display: flex;
  align-items: center;

  .ed-image__brand {
    &:not(:first-of-type) {
      margin-left: 10px;
    }

    width: 100%;
    max-width: 80px;
    @media screen and (min-width: 768px) {
      max-width: 90px;
    }

    img {
      max-height: 60px;
    }
  }
}
</style>
